export {
  Cwitness,
  CwitnessContent,
  WITNESS_CARD_IMAGE_SRCS,
} from './Cwitness';
export type { CwitnessContentProps, CwitnessProps } from './Cwitness';
